import client, { deserializer } from 'services/client'
import { toCamel, toSnake } from 'change-object-case'

const BASE_PATH = '/v2/agentic/prompts'

async function getAgenticPrompts(params = {}) {
  const filteredParams = Object.fromEntries(Object.entries(params).filter(([, v]) => v != null))
  const response = await client().get(BASE_PATH, { params: toSnake(filteredParams) })

  return {
    data: deserializer.deserialize(response),
    meta: toCamel(response.meta || {}),
  }
}

async function getAgenticPrompt(id) {
  const response = await client().get(`${BASE_PATH}/${id}`)

  return deserializer.deserialize(response)
}

async function getAgenticPromptMetadata() {
  const response = await client().get(`${BASE_PATH}/metadata`)

  return toCamel(response.data || {}, { arrayRecursive: true })
}

async function reorderAgenticPrompts(promptPositions) {
  await client().patch(`${BASE_PATH}/positions`, toSnake({ promptPositions }))
}

async function createAgenticPrompt(prompt) {
  const response = await client().post(BASE_PATH, toSnake(prompt))

  return deserializer.deserialize(response)
}

async function updateAgenticPrompt(id, prompt) {
  const response = await client().patch(`${BASE_PATH}/${id}`, toSnake(prompt))

  return deserializer.deserialize(response)
}

async function deleteAgenticPrompt(id) {
  await client().delete(`${BASE_PATH}/${id}`)
}

export {
  getAgenticPrompts,
  getAgenticPrompt,
  getAgenticPromptMetadata,
  reorderAgenticPrompts,
  createAgenticPrompt,
  updateAgenticPrompt,
  deleteAgenticPrompt,
}
